<div data-test-id="app-info" style="display: none;">
  <p data-test-id="app-info-name">App.Name: {{info.name}}</p>
  <p data-test-id="app-info-version">App.Version: {{info.version}}</p>
  <p data-test-id="app-info-website">App.Website: {{info.websiteName}}</p>
  <p data-test-id="app-info-hostname">Env.Hostname: {{info.hostname}}</p>
  <p data-test-id="app-info-utc">DateTime.UtcNow: {{info.utcNow}}</p>
  <p data-test-id="app-info-b2c-api">B2C Api: {{info.api}}</p>
</div>
